import {Component, OnDestroy, OnInit, effect, inject, Signal} from '@angular/core';
import {RevenueRestService} from "../../core/revenue/services/revenue.rest.service";
import {UserService} from "../../core/user/services/user.service";
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {CsvService} from "../../core/export/csv.service";
import {PdfService} from "../../core/export/pdf.service";
import {AccountService} from "../../core/account/services/account.rest.service";
import {GoLiveService} from "../../core/base/go.live.service";
import {EChartsType} from "echarts/core";
import {RevenuePdfData, PdfConfig} from "../../core/revenue/interfaces/revenuePdfData.interface";

@Component({
    selector: 'app-revenue',
    templateUrl: './revenue.component.html',
    styleUrls: ['./revenue.component.scss'],
    standalone: false
})
export class RevenueComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$ = new Subject<boolean>();
  public chartOptions: any;
  protected chartRxPacketsOptions: any;
  public revenue: any;
  public today: Date = new Date();
  private selectedIdf: any = null;
  private revenueRestService: RevenueRestService = inject(RevenueRestService);
  private userService: UserService = inject(UserService);
  private exportCsvService: CsvService = inject(CsvService);
  private accountRestService: AccountService = inject(AccountService)
  private exportPdfService: PdfService = inject(PdfService);
  private goLive = inject(GoLiveService);
  readonly isLive: Signal<boolean> = this.goLive.isLive('dieselPrices');
  private echartsInstanceRx?: EChartsType;
  private echartsInstance?: EChartsType;

  constructor() {
    effect(() => {
      const idf = this.userService.selectedIdf();
      if (idf) {
        this.selectedIdf = idf;
        this.requestRevenue(idf);
      }
    });
    this.goLive.register('dieselPrices', new Date('2026-06-01T00:00:00'));
  }

  ngOnInit() {
    this.chartOptions = {
      // title: {
      //   text: 'Monatlicher Umsatzverlauf',
      //   textStyle: {
      //     fontFamily: 'Raleway SemiBold',
      //     fontSize: 22,
      //   }
      // },
      xAxis: {
        axisLabel: {
          fontSize: 14,
          color: '#999999',
          padding: [10, 0, 0, 0],
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        type: 'category',
        boundaryGap: false,
        data: ['Jan', 'Feb', 'März', 'April', 'Mai', 'Juni', 'Juli', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: this.formatYAxisLabel,
          fontSize: 14,
          color: '#999999',
          padding: [0, 10, 5, 0],
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
      },
      legend: {
        data: [
          {
            name: 'Non-RX-Umsatz',
            icon: 'circle',
            backgroundColor: '#ed1c24'
          }
          ,
          {
            name: 'RX-Umsatz inkl HP',
            icon: 'circle',
            backgroundColor: '#545454'
          },
          {
            name: 'HP-Umsatz',
            icon: 'circle',
            backgroundColor: '#2699fb'
          }
        ],
        bottom: 0,
        left: 120,
        itemGap: 35
      },
      series: [
        {
          name: 'Umsatz',
          data: [820, 932, 901, 934, 1290, 1330, 1320, 215, 879, 654, 825, 454],
          type: 'line'
        }
      ]
    }


  this.chartRxPacketsOptions = {
    // title: {
    //   text: 'Anzahl RX Packungen',
    //   textStyle: {
    //     fontFamily: 'Raleway SemiBold',
    //     fontSize: 22,
    //   }
    // },
    xAxis: {
      axisLabel: {
        fontSize: 14,
        color: '#999999',
        padding: [10, 0, 0, 0],
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      type: 'category',
      boundaryGap: false,
      data: ['Jan', 'Feb', 'März', 'April', 'Mai', 'Juni', 'Juli', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: this.formatYAxisLabel,
        fontSize: 14,
        color: '#999999',
        padding: [0, 10, 5, 0],
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
    },
    series: [
      {
        name: 'Umsatz',
        data: [820, 932, 901, 934, 1290, 1330, 1320, 215, 879, 654, 825, 454],
        type: 'line'
      }
    ]
  }
}

  requestRevenue(idf: any) {
    this.revenueRestService.requestRevenue(idf).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
      this.revenue = res.return_object;
      this.loadRevenue(res.return_object);
    });
  }

  loadRevenue(data: any) {
    const filteredChart = Array.prototype.slice.call(data.chart.series);
    filteredChart.splice(2, 1);
    filteredChart.splice(0, 1);

    const filteredRxChart = Array.prototype.slice.call(data.rx_package_chart.series);
    this.chartOptions = {
      // title: {
      //   text: 'Monatlicher Umsatzverlauf',
      //   textStyle: {
      //     fontFamily: 'Raleway SemiBold',
      //     fontSize: 22,
      //   }
      // },
      tooltip: {
        trigger: 'axis',
        formatter: this.formatTooltipEuro
      },
      xAxis: {
        axisLabel: {
          fontSize: 14,
          color: '#999999',
          padding: [10, 0, 0, 0],
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        type: 'category',
        boundaryGap: false,
        data: data.chart.x_axis
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          fontSize: 14,
          color: '#999999',
          padding: [0, 10, 5, 0],
          formatter: (value: number) => this.formatYAxisLabel(value) + ' €'
        }
      },
      series: filteredChart,
      legend: {
        data: [
          {
            name: 'Non-RX-Umsatz',
            icon: 'circle',
            backgroundColor: '#ed1c24'
          },
          {
            name: 'RX-Umsatz inkl HP',
            icon: 'circle',
            backgroundColor: '#545454'
          },
          {
            name: 'HP-Umsatz',
            icon: 'circle',
            backgroundColor: '#2699fb'
          }
        ],
        bottom: 0,
        left: 120,
        itemGap: 35
      },
      color: [
        '#ed1c24',
        '#545454',
        '#2699fb',
        '#91c7ae',
        '#2699fb',
      ],
    }
    this.chartRxPacketsOptions = {
      // title: {
      //   text: 'Anzahl RX Packungen',
      //   textStyle: {
      //     fontFamily: 'Raleway SemiBold',
      //     fontSize: 22,
      //   }
      // },
      tooltip: {
        trigger: 'axis',
        formatter: this.formatTooltip
      },
      xAxis: {
        axisLabel: {
          fontSize: 14,
          color: '#999999',
          padding: [10, 0, 0, 0],
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        type: 'category',
        boundaryGap: false,
        data: data.rx_package_chart.x_axis
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          fontSize: 14,
          color: '#999999',
          padding: [0, 10, 5, 0],
          formatter: (value: number) => this.formatYAxisLabel(value)
        }
      },
      series: filteredRxChart,
      // legend: {
      //   bottom: 0,
      //   left: 120,
      //   itemGap: 35
      // },
      color: [
        '#ed1c24',
        '#545454',
        '#2699fb',
        '#91c7ae',
        '#2699fb',
      ],
    }
  }

  /**
   * download revenue as PDF
   */
  savePdf(type: 'Gesamt' | 'RXPackets') {
    const configs: Record<'Gesamt' | 'RXPackets', () => PdfConfig> = {
      Gesamt: () => ({
        title: 'Monatlicher Umsatzverlauf',
        filename: 'Monatlicher_Umsatzverlauf_',
        rev: this.revenue.chart,
        instance: this.echartsInstance,
        cols: [['Monat', 'RX-Umsatz inkl. HP', 'HP-Umsatz', 'Non-RX-Umsatz']],
        trimSeries: (series: any[]) => {
          const copy = series.slice();
          copy.splice(2, 1);
          copy.splice(0, 1);
          return copy;
        },
        formatValues: true,
      }),
      RXPackets: () => ({
        title: 'Anzahl RX Packungen',
        filename: 'Anzahl_RX_Packungen_',
        rev: this.revenue.rx_package_chart,
        instance: this.echartsInstanceRx,
        cols: [['Monat', 'Anzahl RX Packungen']],
        formatValues: false,
      }),
    }
    const { title, filename, rev, instance, cols, trimSeries, formatValues } = configs[type]();

    if (!instance || !rev) {
      return;
    }

    const idf = this.userService.selectedIdf() ?? '';
    const name = this.userService.pharmacyName() ?? '';

    let filteredChart = Array.prototype.slice.call(rev.series);
    if (trimSeries) {
      filteredChart = trimSeries(filteredChart);
    }

    const tableMonths: any = rev.x_axis;
    const imgData = instance.getDataURL({ pixelRatio: 2 });
    const chartWidth = instance.getWidth();
    const chartHeight = instance.getHeight();

    const values = this.prepareDataForPdf(tableMonths, filteredChart, formatValues ?? true);
    const data: RevenuePdfData = {
      rows: values,
      cols,
      fileName: filename + idf,
      title,
      idf,
      name,
    };

    this.exportPdfService.revenuePdf(data, imgData, chartHeight, chartWidth);
  }

  prepareDataForPdf(months: any[], series: any[], formatValues: boolean) {
    return months.map((month, i) => [
      month,
      ...series.map(s => {
        const v = Number(s.data[i] ?? 0);
        return formatValues ? `${this.pdfEuro.format(v)} €` : this.pdfInt.format(v);
      }),
    ]);
  }

  private readonly pdfEuro = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  private readonly pdfInt = new Intl.NumberFormat('de-DE');

  formatYAxisLabel(value: { toLocaleString: (arg0: string) => string; }) {
    return value.toLocaleString('de-DE');
  }

  formatTooltipEuro(params: string | any[]) {
    let res = params[0].name;
    for (let i = 0, l = params.length; i < l; i++) {
      res += '<br/>' + params[i].marker + params[i].seriesName + ': ' + params[i].value.toLocaleString('de-DE') + ' €';
    }
    return res;
  }

  formatTooltip(params: string | any[]) {
    let res = params[0].name;
    for (let i = 0, l = params.length; i < l; i++) {
      res += '<br/>' + params[i].marker + params[i].seriesName + ': ' + params[i].value.toLocaleString('de-DE');
    }
    return res;
  }

  /**
   * Unsubscribe from all subscriptions.
   */
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next(false);
    this.ngUnsubscribe$.complete();
  }

  protected onChartInit(ec: EChartsType) {
    this.echartsInstance = ec;
  }

  protected onChartInitRx(ec: EChartsType) {
    this.echartsInstanceRx = ec;
  }
}
